import React from 'react';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';

const TermsElements = (props) => {
    if (!props?.title && !props?.additional_text && !props?.descriptions && !props?.items) return null;

    return (
        <div data-test-id="terms-wr" className={"widget widget-terms" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row mx-auto p-0">
                <div className="col-12">
                    {props?.title ? <h3 data-test-id="terms-title" className={(props?.dark ? "text-white " : "") + "mb-4"}>{props.title}</h3> : null}
                    {props?.additional_text ? <p data-test-id="terms-ver" className={(props?.dark ? "text-white " : "") + "mb-4 text-medium text-sm-small"}>{props.additional_text}</p> : null}
                    {props?.descriptions ? <div data-test-id="terms-description" className={"editor mb-4" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.descriptions) }}></div> : null}
                </div>
                <div className="col-12">
                    {
                        props?.items.map((term, index) => {
                            if (!term?.descriptions) return null;
                            return (
                                <div key={"t_" + index} className="mb-3">
                                    {term?.title ? <p data-test-id={"terms-el-title-" + index} className={(props?.dark ? "text-white " : "") + "text-medium text-sm-small text-bold mb-12"}>{term.title}</p> : null}
                                    {term?.descriptions ? <div data-test-id={"terms-el-description-" + index} className={"editor ml-0 ml-md-5" + (props?.dark ? " bg-dark" : "")} dangerouslySetInnerHTML={{ __html: term.descriptions }}></div> : null}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

TermsElements.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    items: PropTypes.array,
    className: PropTypes.string,
};

export default TermsElements;
